import React from 'react';
import { Main } from './components';

const Process: React.FC = () => <Main />;

export default Process;
